export { renderInteractionTag_unstable as renderInteractionTag } from '@fluentui/react-tags';
